import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import templateMarkup from 'raw-loader!./historicalgraph-widget.html';
import moment from 'moment-timezone';



    function HistoricalGraphWidget(params) {
        var self = this;
        var options = params.observableOptions();

        self.observableOptions = params.observableOptions;
        self.observableData = params.observableData;
        self.panelTemplate = params.panelTemplate;
        self.widgetSignals = params.widgetSignals;
        self.dataProvider = params.dataProvider;
        self.viewLevelOptions = params.viewLevelOptions;
        self.subscriptions = [];
        self.loadMode = true;

        self.totalValue = ko.observable();

        self.type = options.type;
        self.selectedDisplayType = ko.observable(options.selectedDisplayType);

        self.tableVisible = ko.observable(self.selectedDisplayType() === 'Table');
        self.pieVisible = ko.observable(self.selectedDisplayType() === 'Pie');
        self.barVisible = ko.observable(self.selectedDisplayType() === 'Bar');
        self.barTrendVisible = ko.observable(self.selectedDisplayType() === 'Bar Trend');
        self.lineTrendVisible = ko.observable(self.selectedDisplayType() === 'Line Trend');
        self.areaTrendVisible = ko.observable(self.selectedDisplayType() === 'Area Trend');
        self.stackedAreaTrendVisible = ko.observable(self.selectedDisplayType() === 'Stacked Area Trend');

        // METHODS
        self.clickCallback = function (e1) {
            var start;

            if (e1.point.x && (moment(e1.point.x).isValid()) && (moment(e1.point.x).isAfter('2000-01-01T00:00:00Z'))) {
                var utc = moment.tz(e1.point.x, 'UTC');
                start = utc.format('YYYY-MM-DD HH:mm:ss');//2016-06-22 09:00:00
                self.loadMode = true;
                self.viewLevelOptions(start);
                self.loadMode = false;
            }
        };

        self.setVisibilities = function() {
            self.tableVisible(self.selectedDisplayType() === 'Table');
            self.pieVisible(self.selectedDisplayType() === 'Pie');
            self.barVisible(self.selectedDisplayType() === 'Bar');
            self.barTrendVisible(self.selectedDisplayType() === 'Bar Trend');
            self.lineTrendVisible(self.selectedDisplayType() === 'Line Trend');
            self.areaTrendVisible(self.selectedDisplayType() === 'Area Trend');
            self.stackedAreaTrendVisible(self.selectedDisplayType() === 'Stacked Area Trend');
        };

        self.loadOptions = function() {
            var options = params.observableOptions();

            if (options.selectedDisplayType) {
                self.selectedDisplayType(options.selectedDisplayType);
            }
            self.setVisibilities();
            self.loadMode = false;
        };

        self.subscriptions.push(params.observableData.subscribe(function () {
            if (!self.loadMode) {
                self.RefreshData();
            }
        }));

        self.loadData = function () {
            var defoptions = self.panelTemplate.defaultOptions;
            var extendedOptions = $.extend({}, options, defoptions);

            self.observableOptions(extendedOptions);

            var metric = '';
            var group = '';
            var aggregation = 'sum';
            var disptype = '';
            var timegrain = '';
            var dataset = '';
            var eptags = [];

            if (!_.isEmpty(defoptions.selectedMetricColumnNames))  {
                metric = _.toLower(defoptions.selectedMetricColumnNames[0]);
            }
            if (!_.isEmpty(defoptions.selectedGroupColumnNames)) {
                group = _.toLower(defoptions.selectedGroupColumnNames.join());
            }
            if (!_.isEmpty(defoptions.selectedAggregations)) {
                aggregation = defoptions.selectedAggregations[0];
            }
            if (defoptions.selectedDisplayType) {
                disptype = defoptions.selectedDisplayType;
            }
            if (defoptions.selectedTimeGrain !== null) {
                timegrain = defoptions.selectedTimeGrain;
            }
            if (!_.isEmpty(defoptions.selectedDatasetNames)) {
                dataset = defoptions.selectedDatasetNames[0];
            }
            if (!_.isEmpty(defoptions.selectedEndpointTags)) {
                eptags = defoptions.selectedEndpointTags;
            }

            var obsparams = params.observableParamsList[0]();
            obsparams.queryId = "FlexAccessQuery";

            var paramsTemp = params.viewLevelOptions();

            if (metric) {
                paramsTemp.aggregatefact = aggregation + '(' + metric + ')';
                paramsTemp.groupby = group;
            } else {
                paramsTemp.aggregatefact = '';
                paramsTemp.groupby = '';
            }
            var wco = (paramsTemp.WhereConditionObj && (paramsTemp.WhereConditionObj.length > 0)) ? paramsTemp.WhereConditionObj : params.observableOptions().whereConditionObj;

            paramsTemp.WhereCondition = ko.toJSON(wco);
            paramsTemp.filter = '1=1';
            paramsTemp.timegrain = timegrain;
            paramsTemp.tag = eptags.join(',');
            paramsTemp.dataset = dataset;
            paramsTemp.pageNum = 1;
            paramsTemp.pageSize = params.observableOptions().pageSize;
            paramsTemp.sortIndex = params.observableOptions().sortIndex;
            paramsTemp.sortColumn = "";

            obsparams.paramsJson = ko.toJSON(paramsTemp);
            obsparams.panelId = options.id;

            if (self.widgetSignals) {
                self.widgetSignals.dataRequested.dispatch();
            }
            params.observableParamsList[0](obsparams);
        };
        // END METHODS

        if (params.viewLevelOptions) {
            self.subscriptions.push(params.viewLevelOptions.subscribe(function() {
                if (!self.loadMode) {
                    self.loadData();
                }
            }));
        }
        self.loadOptions();
        self.loadData();
    }

    HistoricalGraphWidget.prototype.RefreshData = function () {
        var self = this;
        var data = self.observableData();

        if (!$.isEmptyObject(data.datasets)) {
            if (self.widgetSignals) {
                self.widgetSignals.dataLoaded.dispatch();
            }
            if (data.groupSums && (data.groupSums.length > 0)) {
                var maxtime = data.groupSums[0].maxtime;

                if (maxtime) {
                    var utc = moment.tz(maxtime, 'UTC');
                    var start = utc.format('YYYY-MM-DD HH:mm:ss');//2016-06-22 09:00:00

                    self.loadMode = true;
                    self.viewLevelOptions(start);
                    self.loadMode = false;

                } else {
                    throw new Error('No maxtime provided! ' + JSON.stringify(data.groupSums[0]));
                }
            }
        }
    };

    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    HistoricalGraphWidget.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default { viewModel: HistoricalGraphWidget, template: templateMarkup };
